export default "__VITE_ASSET__4fR8z7KM__"